<template>
    <el-container class="app" direction="vertical">
        <router-view></router-view>
    </el-container>
</template>

<script>
import query from '@/constants/query';

export default {
    created() {
        // XXX: 默认登录用户管理中心（本地开发调试专用）
        if (
            location.hostname === 'localhost' &&
            location.href.indexOf('appKey') === -1
        ) {
            this.$router.push({
                query: {
                    ...this.$route.query,
                    appKey: '4201a7da-6613-44b1-95e6-d33083686be5',
                    redirectUrl: 'http://admin-account-test.test.geely.com/',
                    resourceType: 3
                }
            });
        }

        // 如果之前使用过国际版，则跳转过来切换成国际版
        if (
            this.$store.state.international.type === 'International' &&
            location.href.indexOf('internationalLogin') === -1
        ) {
            // console.log('当前为国际版')
            this.$router.replace({
                name: 'internationalLogin',
                query: {
                    ...query,
                    ...this.$route.query
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.app {
    height: 100%;
    font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
    -webkit-font-smoothing: antialiased;
}
</style>
